import { takeLatest, put, all, call } from "redux-saga/effects";
import {
  FETCH_RETURN_ORDERS_LIST_REQUEST,
  FETCH_RETURN_ORDERS_LIST_SUCCESS,
  FETCH__MORE_RETURN_ORDERS_LIST_SUCCESS,
  FETCH_MORE_RETURN_ORDERS_LIST_REQUEST,
  CANCEL_RETURN_REQUEST,
  RVP_PICKUP_DATE,
  SET_MODAL_VALUES,
} from "../reducers/actionTypes";
import {
  fetchReturnOrdersV2,
  returnRequestCancelV2,
  scheduleRVPPickupDate,
} from "@services/api";
import color from "@constants/color";
import ToastMessage from "@components/Toast";

function* fetchAllReturnOrders(action) {
  try {
    const { offset = 0, limit = 10, query = "" } = action && action.payload;
    const { data = {} } = yield call(fetchReturnOrdersV2, {
      offset,
      limit,
      query,
    });
    yield put({
      type: FETCH_RETURN_ORDERS_LIST_SUCCESS,
      returnOrders: data,
      count: data.length,
    });
  } catch {}
}

function* fetchMoreReturnOrders(action) {
  try {
    const { offset = 0, limit = 10, query = "" } = action && action.payload;
    const { data } = yield call(fetchReturnOrdersV2, { offset, limit, query });

    yield put({
      type: FETCH__MORE_RETURN_ORDERS_LIST_SUCCESS,
      returnOrders: data,
    });
  } catch {}
}

function* cancelReturnRequest(action) {
  try {
    const { return_req_id, type } = action && action.payload;
    const { data } = yield call(returnRequestCancelV2, {
      return_req_id,
      type,
    });
    ToastMessage("success", data?.message);

    yield fetchAllReturnOrders({
      type: FETCH_RETURN_ORDERS_LIST_REQUEST,
      payload: {},
    });
  } catch {}
}

function* rvpPickupDate(action) {
  try {
    const { data } = yield call(scheduleRVPPickupDate, action?.payload);

    yield put({
      type: SET_MODAL_VALUES,
      payload: {
        heading: data?.heading,
        message: data?.message,
        buttons: [{ text: data?.cta_text, color: color.primary }],
      },
    });
  } catch {}
}

export default function* root() {
  yield all([
    takeLatest(FETCH_RETURN_ORDERS_LIST_REQUEST, fetchAllReturnOrders),
    takeLatest(FETCH_MORE_RETURN_ORDERS_LIST_REQUEST, fetchMoreReturnOrders),
    takeLatest(CANCEL_RETURN_REQUEST, cancelReturnRequest),
    takeLatest(RVP_PICKUP_DATE, rvpPickupDate),
  ]);
}
